import React from 'react';
import { SubcategoryState } from './subcategoryState/SubcategoryState';
import { SubcategoryControlPanel } from './components/SubcategoryControlPanel/SubcategoryControlPanel';
import { Subcategories } from './components/Subcategories/Subcategories';
import { ModalWindows } from './components/ModalWindows';
import style from './index.module.scss';

export const SubcategoryPageV2: React.FC = () => {
	return (
		<SubcategoryState>
			<div className={style.container} data-test="SubcategoryPage">
				<SubcategoryControlPanel />
				<Subcategories />
				<ModalWindows />
			</div>
		</SubcategoryState>
	);
};
